"use client"

import dynamic from 'next/dynamic';

export const Modal = dynamic(() => import('./Modal'), {
  ssr: false,
  loading: () => null,
});

export { ModalThin } from './ModalThin';
export { ModalThinHeader } from './ModalThinHeader';
export { ModalThinButtonsBar } from './ModalThinButtonsBar';
export { usePopupWizard } from './wizard';
